'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "error", "value", "onBlur", "onChange"];
import UIFormControl from 'UIComponents/form/UIFormControl';
import I18n from 'I18n';
import { getTransferableProps } from './filterInputProps';
import PropTypes from 'prop-types';
import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import { fromSimpleDate, toSimpleDate } from '../../utilities/momentSimpleDateConversion';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIDateRange from 'UIComponents/dates/UIDateRange';
import { useEffect, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorDateRangeInput = props => {
  const {
      className,
      error,
      value: condition,
      onBlur,
      onChange
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [isOpen, setIsOpen] = useState(false);
  const fieldType = condition.field.type;
  const onChangeLocal = evt => {
    const startDate = fromSimpleDate(fieldType, evt.target.value.startDate);
    const endDate = fromSimpleDate(fieldType, evt.target.value.endDate);
    onChange(syntheticEvent(condition.merge({
      value: startDate,
      highValue: endDate
    })));
  };
  const prevIsOpen = useRef(isOpen);
  useEffect(() => {
    if (typeof onBlur === 'function' && isOpen === false && prevIsOpen.current === true) {
      onBlur();
    }
    prevIsOpen.current = isOpen;
  }, [isOpen, onBlur]);
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const inputValue = {
    startDate: toSimpleDate(fieldType, condition.get('value')),
    endDate: toSimpleDate(fieldType, condition.get('highValue'))
  };
  const transferableProps = getTransferableProps(rest);
  const {
    ['data-selenium-test']: dataSeleniumTest,
    placeholder,
    disabled,
    onKeyDown,
    onKeyPress,
    onKeyUp,
    readOnly
  } = transferableProps;
  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
    className: className,
    error: isError,
    validationMessage: isError ? errorMessage : null,
    children: /*#__PURE__*/_jsx(UIDateRange, {
      "data-selenium-test": dataSeleniumTest,
      disabled: disabled,
      onChange: onChangeLocal,
      onKeyDown: onKeyDown,
      onKeyPress: onKeyPress,
      onKeyUp: onKeyUp,
      onOpenChange: evt => setIsOpen(evt.target.value),
      placeholder: placeholder,
      readOnly: readOnly,
      value: inputValue
    })
  });
};
FilterOperatorDateRangeInput.propTypes = {
  className: PropTypes.string,
  error: FilterOperatorErrorType.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: FilterOperatorType.isRequired
};
export default FilterOperatorDateRangeInput;